// V3 collection sidebar. Ella refreshes filters by copying each `.js-filter` block from the
// fetched HTML; the V3 panel is custom markup with no such blocks, so nothing updated after an
// AJAX filter — chips, "Limpar tudo" and active states only appeared on a full page load.
(function () {
    'use strict';

    var PANEL_ID = 'main-collection-filters';

    if (typeof CollectionFiltersForm !== 'undefined') {
        var original = CollectionFiltersForm.renderFilters;

        // Replace the whole panel instead: the new <collection-filters-form> runs its own
        // constructor, so Ella's submit listeners rebind without any extra wiring.
        CollectionFiltersForm.renderFilters = function (html, event) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.getElementById(PANEL_ID);
            var current = document.getElementById(PANEL_ID);

            if (!next || !current) return original.call(this, html, event);
            current.innerHTML = next.innerHTML;

            // The result count also lives outside the panel: in the search H1 and in the
            // mobile count row. Both are static Liquid, so they kept the unfiltered number.
            ['.clv3-title', '.clv3-count--mobile'].forEach(function (selector) {
                var fresh = doc.querySelector(selector);
                var stale = document.querySelector(selector);
                if (fresh && stale) stale.innerHTML = fresh.innerHTML;
            });
        };
    }

    // Warm the swap before it is asked for: without this the click sets a src the browser
    // has never fetched, so the old colour stays on screen while it downloads. Same trick
    // theme.js uses for Ella's own card swatches.
    ['pointerenter', 'touchstart'].forEach(function (type) {
        document.addEventListener(type, function (event) {
            var swatch = event.target.closest && event.target.closest('[data-clv3-swatch]');
            if (!swatch || swatch.dataset.warmed) return;
            swatch.dataset.warmed = '1';
            [swatch.dataset.main, swatch.dataset.hover].forEach(function (url) {
                if (url) { new Image().src = url; }
            });
        }, { capture: true, passive: true });
    });

    // Colour swatch: swap the card's images and point its links at that variant, the way
    // Ella's own product cards behave. Delegated, since the grid is replaced on filtering.
    document.addEventListener('click', function (event) {
        var swatch = event.target.closest('[data-clv3-swatch]');
        if (!swatch) return;

        var card = swatch.closest('.clv3-card');
        var main = card.querySelector('.clv3-card__img--main');
        var hover = card.querySelector('.clv3-card__img--hover');

        if (main && swatch.dataset.main) {
            main.src = swatch.dataset.main;
            main.srcset = swatch.dataset.mainSrcset || '';
        }
        // No second image for this colour: drop the hover rather than reveal another colour.
        if (hover) {
            if (swatch.dataset.hover) {
                hover.src = swatch.dataset.hover;
                hover.srcset = '';
                hover.hidden = false;
            } else {
                hover.hidden = true;
            }
        }

        if (swatch.dataset.url) {
            card.querySelectorAll('a[href]').forEach(function (link) {
                link.href = swatch.dataset.url;
            });
        }

        card.querySelectorAll('[data-clv3-swatch]').forEach(function (other) {
            other.classList.toggle('is-selected', other === swatch);
        });

        // Re-point the quick-add sizes at this colour: the same size is a different
        // variant per colourway, and its availability differs too.
        applyColour(card.querySelector('[data-clv3-quickadd]'), swatch.getAttribute('aria-label'));

        showTouchTip(swatch);
    });

    // Touch has no hover, so the colour name appears on tap and clears itself. Gated on
    // `hover: none` rather than a width query: a small laptop with a mouse still gets the
    // CSS hover, a large tablet does not.
    var TIP_MS = 1600;
    var tipTimer;

    function clearTips() {
        clearTimeout(tipTimer);
        document.querySelectorAll('.clv3-thumb.is-tipped').forEach(function (tile) {
            tile.classList.remove('is-tipped');
        });
    }

    function showTouchTip(swatch) {
        if (!window.matchMedia('(hover: none)').matches) return;
        var tile = swatch.closest('.clv3-thumb');
        if (!tile) return;
        clearTips();
        tile.classList.add('is-tipped');
        tipTimer = setTimeout(clearTips, TIP_MS);
    }

    // WCAG 1.4.13: content revealed on hover or focus must be dismissible.
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') clearTips();
    });

    // Point every size button at the variant for `colour`, and reset the pending selection.
    function applyColour(group, colour) {
        if (!group || !colour) return;

        var table;
        try {
            table = JSON.parse(group.dataset.variants || '{}');
        } catch (error) {
            console.error('quick add: unreadable variant map', error);
            return;
        }

        var sizes = table[colour];
        if (!sizes) return;
        group.dataset.colour = colour;

        group.querySelectorAll('.clv3-size').forEach(function (button) {
            var entry = sizes[button.dataset.size];
            var id = entry && entry[1] ? entry[0] : null;
            button.classList.remove('is-selected');
            button.classList.toggle('is-out', !id);
            button.disabled = !id;
            if (id) {
                button.dataset.variantId = id;
            } else {
                delete button.dataset.variantId;
            }
        });

        var atc = group.querySelector('[data-clv3-atc]');
        if (atc) {
            atc.disabled = true;
            delete atc.dataset.variantId;
        }
    }

    // Quick add: pick a size, then the button posts that variant. Delegated because the grid
    // is replaced wholesale on every filter change.
    document.addEventListener('click', function (event) {
        var size = event.target.closest('.clv3-size');
        if (size && !size.disabled) {
            var group = size.closest('[data-clv3-quickadd]');
            group.querySelectorAll('.clv3-size').forEach(function (b) { b.classList.remove('is-selected'); });
            size.classList.add('is-selected');
            var atc = group.querySelector('[data-clv3-atc]');
            atc.disabled = false;
            atc.dataset.variantId = size.dataset.variantId;
            return;
        }

        var button = event.target.closest('[data-clv3-atc]');
        if (!button || button.disabled || !button.dataset.variantId) return;

        button.disabled = true;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
        })
            .then(function (response) {
                if (!response.ok) throw new Error('cart/add returned ' + response.status);
                // Ella's drawer listens for this; without it the header count goes stale.
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            })
            .catch(function (error) {
                console.error('quick add failed', error);
            })
            .finally(function () {
                button.disabled = false;
            });
    });

    // FAQ accordion. Same technique custom-product-faq.liquid uses: <details> toggles
    // instantly, so the answer's height is animated with the Web Animations API and the
    // open state is applied at the end of the collapse.
    var FAQ_MS = 280;

    function reduceMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function faqCollapse(row) {
        var answer = row.querySelector('.cfq-row__a');
        var from = answer.scrollHeight;
        row.dataset.animating = '1';
        answer.animate({ height: [from + 'px', '0px'] }, { duration: FAQ_MS, easing: 'ease' })
            .onfinish = function () {
                row.open = false;
                answer.style.height = '';
                row.dataset.animating = '';
            };
    }

    function faqExpand(row) {
        var answer = row.querySelector('.cfq-row__a');
        row.dataset.animating = '1';
        row.open = true;
        var to = answer.scrollHeight;
        answer.animate({ height: ['0px', to + 'px'] }, { duration: FAQ_MS, easing: 'ease' })
            .onfinish = function () {
                answer.style.height = '';
                row.dataset.animating = '';
            };
    }

    document.addEventListener('click', function (event) {
        var summary = event.target.closest('.cfq-row__q');
        if (!summary) return;

        var row = summary.parentElement;
        if (row.dataset.animating) return;

        // One open at a time. Native <details name> would do this, but it toggles
        // instantly and would fight the height animation.
        var list = row.closest('.cfq-list');
        if (!row.open && list) {
            list.querySelectorAll('.cfq-row[open]').forEach(function (other) {
                if (other !== row && !other.dataset.animating) faqCollapse(other);
            });
        }

        if (reduceMotion()) return;
        event.preventDefault();

        if (row.open) {
            faqCollapse(row);
        } else {
            faqExpand(row);
        }
    });

    // Size guide. theme.js only wires its handlers where a .productView-sizeChart marker
    // exists, which is a product page, so the same two classes are toggled here instead —
    // Ella's CSS supplies the panel, the backdrop and the open animation.
    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-open-size-chart-popup]')) {
            event.preventDefault();
            document.body.classList.add('size-chart-show');
            var popup = document.querySelector('.halo-size-chart-popup');
            if (popup) popup.classList.add('is-show');
            return;
        }

        var inside = event.target.closest('[data-size-chart-popup] .halo-popup-wrapper');
        if (event.target.closest('[data-close-size-chart-popup]') ||
            (document.body.classList.contains('size-chart-show') && !inside)) {
            document.body.classList.remove('size-chart-show');
            document.querySelectorAll('.halo-size-chart-popup').forEach(function (el) {
                el.classList.remove('is-show');
            });
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !document.body.classList.contains('size-chart-show')) return;
        document.body.classList.remove('size-chart-show');
        document.querySelectorAll('.halo-size-chart-popup').forEach(function (el) {
            el.classList.remove('is-show');
        });
    });

    // On hover the panel goes absolute, and it is the card's only child, so the card collapses
    // to zero. A full row survives on its siblings, but a part-filled last row disappears and
    // the page shortens under the cursor. Reserve each card's natural height up front.
    function lockCardHeights() {
        var cards = Array.prototype.slice.call(document.querySelectorAll('.collection-v3 .clv3-card'));
        if (!cards.length) return;

        cards.forEach(function (card) { card.style.minHeight = ''; });
        cards.forEach(function (card) {
            if (card.matches(':hover')) return;
            card.style.minHeight = card.getBoundingClientRect().height + 'px';
        });
    }

    // Images settle after load, and filtering swaps the grid out, so re-measure on both.
    function watchGrid() {
        var grid = document.getElementById('CollectionProductGrid');
        if (!grid) return;
        var pending;
        new MutationObserver(function () {
            clearTimeout(pending);
            pending = setTimeout(lockCardHeights, 60);
        }).observe(grid, { childList: true, subtree: true });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(lockCardHeights, 150);
    });
    window.addEventListener('load', lockCardHeights);
    document.addEventListener('DOMContentLoaded', function () { lockCardHeights(); watchGrid(); });

    // Ella's toolbar.js only drops the sticky filter/sort bar below a revealed header when
    // .section-header-navigation carries -show; the mobile header is the separate header-mobile
    // section and never sets it, so the bar sat on top of the header on every scroll-up.
    function followMobileHeader() {
        var header = document.querySelector('.section-header-mobile');
        if (!header) return;
        function place() {
            var shown = header.classList.contains('shopify-section-header-sticky') &&
                !header.classList.contains('shopify-section-header-hidden');
            document.querySelectorAll('.collection-v3 .toolbar[data-toolbar]').forEach(function (bar) {
                bar.style.top = shown ? header.offsetHeight + 'px' : '';
            });
        }
        new MutationObserver(place).observe(header, { attributes: true, attributeFilter: ['class'] });
        place();
    }
    document.addEventListener('DOMContentLoaded', followMobileHeader);

    // Price buckets write the two hidden range inputs, then let Ella's form listener submit.
    // Delegated from the document so the handler survives the panel being replaced.
    document.addEventListener('change', function (event) {
        var box = event.target.closest && event.target.closest('[data-clv3-bucket]');
        if (!box) return;

        var root = box.closest('[data-clv3-price]');
        if (!root) return;

        var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-clv3-bucket]'));
        var on = boxes.filter(function (b) { return b.checked; });
        var lows = on.map(function (b) { return b.dataset.gte; }).filter(Boolean).map(Number);
        var highs = on.map(function (b) { return b.dataset.lte; }).filter(Boolean).map(Number);

        // Any bucket left open-ended makes that side of the range open too.
        var openLow = on.some(function (b) { return !b.dataset.gte; });
        var openHigh = on.some(function (b) { return !b.dataset.lte; });

        root.querySelector('[data-clv3-gte]').value = on.length && !openLow ? Math.min.apply(null, lows) : '';
        root.querySelector('[data-clv3-lte]').value = on.length && !openHigh ? Math.max.apply(null, highs) : '';

        var form = document.getElementById('CollectionFiltersForm');
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
    });
})();
